/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { uploadsControllerCompleteUploadSession } from "./uploadsControllerCompleteUploadSession";
import { uploadsControllerCreateProjectUploadSession } from "./uploadsControllerCreateProjectUploadSession";
import { uploadsControllerSign } from "./uploadsControllerSign";
import { uploadsControllerTriggerFileToPdf } from "./uploadsControllerTriggerFileToPdf";

export function uploadsService() {
  return { uploadsControllerSign, uploadsControllerCreateProjectUploadSession, uploadsControllerCompleteUploadSession, uploadsControllerTriggerFileToPdf }
}